module.exports = __webpack_public_path__ + "img/koda.a0c7434c.jpg";